import React from "react";
import { HiOutlineCalendar } from "react-icons/hi";
import { CHART_PERIODS, formatDateRangeDisplay } from "./aiUsageChartUtils";

const ChartCardHeader = ({
  icon: Icon,
  title,
  subtitle,
  period,
  onPeriodChange,
  dateFrom,
  dateTo,
}) => (
  <div className="border-b border-gray-100 px-5 pt-4 pb-3">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        {Icon ? (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#ECF0FD] text-[#4B6CB7]">
            <Icon className="h-5 w-5" />
          </span>
        ) : null}
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {subtitle ? (
            <p className="mt-0.5 text-xs leading-relaxed text-gray-500">{subtitle}</p>
          ) : null}
          {dateFrom && dateTo ? (
            <p className="mt-2 inline-flex items-center gap-1.5 rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600">
              <HiOutlineCalendar className="h-3.5 w-3.5 shrink-0 text-gray-400" />
              {formatDateRangeDisplay(dateFrom, dateTo)}
            </p>
          ) : null}
        </div>
      </div>

      <div
        className="flex shrink-0 rounded-lg border border-gray-200 bg-gray-50/80 p-1"
        role="group"
        aria-label="Chart period"
      >
        {CHART_PERIODS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            onClick={() => onPeriodChange(preset.id)}
            className={`rounded-md px-3 py-1.5 text-xs font-medium transition-all whitespace-nowrap ${
              period === preset.id
                ? "bg-white text-[#4B6CB7] shadow-sm ring-1 ring-blue-100"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            {preset.shortLabel}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default ChartCardHeader;
